import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../common/ProductCard';
import * as ProductService from '../../services/ProductService';
import { DIRECT_PRODUCTS } from '../../data/ProductData';
import Hero from './Hero'
import NewArrivalsSlider from './NewArrivalsSlider'
import WhyChooseUs from './WhyChooseUs'
import ContactUs from './ContactUs'
import { CircularProgress } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HomePage.css';
import SEOMetaTags from '../common/SEOMetaTags';

function HomePage() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      setLoading(true);
      try {
        // Use direct products instead of API
        const featured = DIRECT_PRODUCTS
          .filter(p => p.featured && p.inStock)
          .slice(0, 8); // Get more products for the slider
        
        setFeaturedProducts(featured);
      } catch (error) {
        console.error('Error fetching featured products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500, // Slightly different from NewArrivals
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <SEOMetaTags 
        title="NM Diamond | Premium Diamond Jewelry Wholesaler in Delhi"
        description="NM Diamond offers exquisite diamond jewelry collections including rings, necklaces, earrings, and bracelets at wholesale prices in Karol Bagh, Delhi. Explore our new arrivals and special offers."
        keywords="diamond jewelry Delhi, wholesale diamond rings, diamond necklaces, diamond earrings, diamond bracelets, Karol Bagh diamond shop, premium diamond jewelry, engagement rings, wedding jewelry"
        canonicalUrl="https://www.nmdiamond.in/"
        ogImage="media/og-image.jpg"
      />
      <div className="homepage">
        <Hero />
        <NewArrivalsSlider />
        
        {/* Featured Products Section */}
        <section className="featured-products">
          <h2 className="section-title">Featured Products</h2>
          <p className="section-subtitle">Discover our exclusive selection of premium jewelry</p>
          <div className="slider-container">
            {loading ? (
              <div className="loading-spinner">
                <CircularProgress />
              </div>
            ) : (
              <Slider {...sliderSettings}>
                {featuredProducts.map(product => (
                  <div key={product.id} className="slider-item">
                    <ProductCard product={product} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </section>
        
        <WhyChooseUs />
        <ContactUs />
      </div>
    </>
  );
}

export default HomePage;